"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const StyledMenu = styles_1.withStyles({
    paper: {
        padding: "0px",
        paddingLeft: "15px",
        paddingRight: "15px",
        marginLeft: "15px",
        paddingTop: "0px !important",
        backgroundColor: "#4D4D4D",
    },
})((props) => (react_1.default.createElement(Menu_1.default, Object.assign({ elevation: 0, getContentAnchorEl: null, style: { padding: "0px" }, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } }, props))));
const StyledMenuItem = styles_1.withStyles(({
    root: {
        backgroundColor: "#4D4D4D",
        padding: "5px",
        fontSize: "0.8em",
        color: "white",
        '&:hover': {
            color: "orange",
            backgroundColor: "#4D4D4D"
        }
    },
}))(MenuItem_1.default);
const useStyles = styles_1.makeStyles(() => styles_1.createStyles({
    mainButton: {
        boxShadow: "none",
        textTransform: "none",
        fontWeight: "normal",
        fontSize: "16px"
    },
    menuItem: {
        fontSize: "14.4px",
        minHeight: "unset",
    },
    styledMenu: {
        padding: "0px",
    }
}));
function NavigationBarButton(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const theme = styles_1.useTheme();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    function openHyperlink(Url) {
        const a = document.createElement("a");
        a.href = Url;
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
        handleClose();
    }
    const buttons = props.NavBarButtonItems.map((btn, index) => react_1.default.createElement(StyledMenuItem, { divider: index < props.NavBarButtonItems.length - 1, key: index, className: classes.menuItem },
        react_1.default.createElement(ListItemText_1.default, { primary: btn.Name, onClick: () => { openHyperlink(btn.Url); }, classes: { primary: classes.menuItem } })));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Button_1.default, { "aria-controls": "customized-menu", "aria-haspopup": "true", variant: "contained", color: "primary", className: classes.mainButton, onClick: handleClick },
            props.Name,
            react_1.default.createElement(ExpandMore_1.default, { style: theme && theme.palette.third ? { color: theme.palette.third.main } : null })),
        react_1.default.createElement(StyledMenu, { id: "customized-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, buttons)));
}
exports.default = NavigationBarButton;
//# sourceMappingURL=NavigationBarButton.js.map